import React from "react"
import Typing from "react-typing-animation"
import { Reveal, Fade } from "react-reveal"
import Layout from "../../components/layout"
import SEO from "../../components/seo"
import ClientStart from "../../components/ClientStart/ClientStart"
import ClientsSlider from "../../components/Slider/Clients"
import cloud_devops from "../../../static/services/cloud-devops.png"
import what_is_devops from "../../../static/services/what-is-devops.png"
import devops_benefitsw from "../../../static/services/devops-benefits.webm"
import devops_benefitsm from "../../../static/services/devops-benefits.mp4"

const CloudAndDevOpsPage = () => (
  <Layout>
    <SEO title="Cloud and DevOps" />

    <div className="hero-section s-section">
      <div className="hero-wrapper other">
        <div className="hero-container">
          <div className="hero-content">
            <h1 className="hero-h1">Cloud and DevOps</h1>
            <Reveal left>
              <p className="hero-p">
                Cloud migrations and optimisations. Our expertise in the cloud
                will help you modernise your infrastructure.
              </p>
            </Reveal>
          </div>

          <div className="hero-content index-header-img">
            <Fade right>
              <img
                src={cloud_devops}
                alt="cloud and devops"
                className="hero-img"
              />
            </Fade>
          </div>
        </div>
      </div>
      <div className="container index-client ">
        <ClientsSlider />
      </div>
    </div>

    <div className="section border-bottom-0">
      <div className="container d-flex what-devops">
        <div className="hero-content">
          <img src={what_is_devops} alt="what is devops" />
        </div>
        <div className="hero-content">
          <Fade bottom>
            <p className="hero-p">
              DevOps is the set of cultural philosophies, practices, and tools
              that work to automate and integrate the processes between software
              development (Dev) and IT operations (Ops), so that teams can
              build, test, and deliver applications and services at high speed.
            </p>
            <p className="hero-p">
              The goal is to continuously improve the value given to your
              customers.
            </p>
          </Fade>
        </div>
      </div>
    </div>
    <div className="vid-container">
      <div className="vid-content">
        <div>
          <video playsInline autoplay="" loop muted controls>
            <source src={devops_benefitsw} type="video/webm" />
            <source src={devops_benefitsm} type="video/mp4" />
          </video>
        </div>
      </div>

      <div className="vid-summary">
        <h2>Benefits of DevOps Implementation</h2>
        <ul>
          <li>Faster Deployment Process</li>
          <li>Rapid Problem Solving</li>
          <li>Improved Customer Service</li>
          <li>Innovation</li>
          <li>Improved Efficiency</li>
        </ul>

        <div>
          <Fade bottom>
            <h3>
              Partner with Us
              <br />
              <Typing speed={2}>
                <span>
                  To help your organisation adopt cloud and devops best
                  practices, and get it right inorder to enhance your business
                  value
                </span>
              </Typing>
            </h3>
          </Fade>
        </div>
      </div>
    </div>
    <div className="section border-bottom-0 why-section">
      <div className="container">
        <h1 className="hero-h1"> Why Choose Us?</h1>
        <p>
          Many organisations are struggling to find the skills they need to
          deliver their Cloud and DevOps programmes. We have vast experience
          working with the leading Cloud Platforms and DevOps technologies. Our
          team, either working alongside your existing engineers or as a
          standalone team, will accelerate your Cloud and DevOps journey.
        </p>
      </div>
    </div>
    <ClientStart />
  </Layout>
)

export default CloudAndDevOpsPage
